import { create } from 'zustand'

type NavigationGuardState = {
    hasUnsavedChanges: boolean
    setUnsavedChanges: (value: boolean) => void
    clearNavigationIntent: () => void
    onNavigationBlocked: (() => void) | null
    setOnNavigationBlockedHandler: (handler: () => void) => void
    setOnNavigationConfirmHandler: (handler: () => void) => void
    onNavigationConfirmHandler: (() => void) | null
}

const useNavigationGuardStore = create<NavigationGuardState>((set) => ({
    hasUnsavedChanges: false,
    onNavigationBlocked: null,
    onNavigationConfirmHandler: null,

    setUnsavedChanges: (value: boolean) => {
        set({ hasUnsavedChanges: value })
    },
    setOnNavigationBlockedHandler: (handler: () => void) => {
        set({ onNavigationBlocked: handler })
    },
    setOnNavigationConfirmHandler: (handler: () => void) => {
        set({ onNavigationConfirmHandler: handler })
    },
    clearNavigationIntent: () => {
        set({ onNavigationBlocked: null })
        set({ onNavigationConfirmHandler: null })
    },
}))

export default useNavigationGuardStore
